module.exports = __webpack_public_path__ + "static/img/2.66f2997a.png";